// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d35ce8c","455":"a5486c67","488":"1c8139f9","946":"e225be2f"}[chunkId] + ".chunk.js";
};